// Shared fetch helper for the design controllers. Centralises the CSRF header,
// JSON vs FormData body handling, and same-origin credentials in one place.

export function request(url, { method, body = null, csrfToken }) {
  const headers = {
    "Accept": "application/json",
    "X-CSRF-Token": csrfToken
  }

  const isFormData = body instanceof FormData
  if (body && !isFormData) headers["Content-Type"] = "application/json"

  return fetch(url, {
    method: method,
    headers: headers,
    body: body ? (isFormData ? body : JSON.stringify(body)) : null,
    credentials: "same-origin"
  })
}

export function post(url, { body = null, csrfToken }) {
  return request(url, { method: "POST", body: body, csrfToken: csrfToken })
}
